import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { CodeDiscount } from '../interfaces/code-discount';

@Injectable()
export class CodeDiscountService {
  private _url = '/api/ClubDiscount/';

  constructor(private http: HttpClient) { }

  create(codeDiscount: CodeDiscount) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + 'addcodediscount', codeDiscount, httpOptions);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/code-discount.service.ts